import { DOCUMENT } from "@/modules/Document/constants/DocumentConstants";
import TooltipButton from "@/shared/components/TooltipButton/TooltipButton.vue";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";

Vue.use(Vuetify);

@Component({
  name: "DocumentInfo",
  components: {
    TooltipButton
  }
})
export default class DocumentInfo extends Vue {
  @Prop({ default: "" })
  private index!: number;
  @Prop({ default: "" })
  private documentName!: string;

  cardClass = STYLE_CLASSES.CARD;
  primaryBtnClassRound = STYLE_CLASSES.PRIMARY_ROUND_BTN;

  ADD_BUTTON = DOCUMENT.LABEL.BUTTON.ADD;

  addDocument() {
    this.$emit(DOCUMENT.EVENT.ADD_DOCUMENT, this.index);
  }
}
